import { createLocalOrUTC } from './from-anything';

export function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/create/local.js
// module id = 154
// module chunks = 3